import React, { FC } from 'react';
import { GenExternalLink, GenNavTile, UniversalLink } from '@/components';
import {
  TypeAccountNavTileFields,
  TypeLink_internalFields,
} from '@/core/generated-types';
import { constructLegacyCustomerPortalLink } from '@/utils/shopSubdomain';
import { TypeMyAccountPageTranslations } from '@/utils/translations';
import {
  CTA_NAMES,
  PAGE_LOCATIONS,
  trackItemClickedEvent,
  CLICKED_ITEM_TYPES,
  buildPayloadUrl,
} from '@/utils/rudderstack';
import useFeature from '@/hooks/useFeature';
import { getCtaTextStyles } from '@/components/utils';

export type PlayKitsTileProps = {
  t: TypeMyAccountPageTranslations;
  userUuid: string;
  hasFilteredSubscriptions: boolean;
  tile: TypeAccountNavTileFields;
  locale: string | undefined;
};

const PlayKitsTile: FC<PlayKitsTileProps> = ({
  t,
  userUuid,
  hasFilteredSubscriptions,
  tile,
  locale,
}) => {
  // TODO: Remove flag and legacyLink https://lovevery.atlassian.net/browse/SRS-847
  const isPageV2Enabled =
    useFeature('retention-enable-subscription-v-2-page') && !!tile.buttonLink; //ensure we have the buttonLink if using V2

  if (!isPageV2Enabled && !hasFilteredSubscriptions) return null;

  const legacyLink = constructLegacyCustomerPortalLink(locale, [
    userUuid,
    'subscriptions',
  ]);

  const sendItemClickedEvent = () => {
    trackItemClickedEvent({
      url: isPageV2Enabled
        ? buildPayloadUrl(tile.buttonLink?.fields as TypeLink_internalFields)
        : legacyLink,
      type: CLICKED_ITEM_TYPES.LINK,
      pageLocation: PAGE_LOCATIONS.PLAY_KITS_TILE,
      cta: CTA_NAMES.VIEW,
    });
  };

  return (
    <GenNavTile
      title={tile.title}
      subTitle={tile.subheader}
      description={tile.description}
      titleDecorator={
        isPageV2Enabled ? (
          <UniversalLink
            link={tile.buttonLink}
            classes={`w-fit underline font-bold ${getCtaTextStyles()}`}
            onClick={sendItemClickedEvent}
          />
        ) : (
          <GenExternalLink
            href={legacyLink}
            cta={t.viewCta}
            onClick={sendItemClickedEvent}
          />
        )
      }
    />
  );
};

export default React.memo(PlayKitsTile);
